import * as actions from "../action.constants";

const initialState = {
  isLoading: false,
  groupModalStatus: false,
  groupModalData: {},
  groupListData: {},
  groupLabelValue: [],
};
const addGroupModalStatus = (state, action) => {
  return {
    ...state,
    groupModalStatus: action.payload,
  };
};

const addGroupModalData = (state, action) => {
  return {
    ...state,
    groupModalData: action.payload,
  };
};

const groupRecieved = (state, action) => {
  return {
    ...state,
    groupListData: action.responsePayload || {},
  };
};

const storeGroupLabelValue = (state, action) => {
  return {
    ...state,
    groupLabelValue: action.payload || [],
  };
};

const permissionListRecieved = (state, action) => {
  return {
    ...state,
    permissions_list: action.responsePayload,
  };
};

const usersListRecieved = (state, action) => {
  return {
    ...state,
    users_list: action.responsePayload,
  };
};

const handlers = {
  [actions.SAVE_ADD_GROUP_MODAL_STATUS]: addGroupModalStatus,
  [actions.SAVE_ADD_GROUP_MODAL_DATA]: addGroupModalData,
  [actions.SAVE_GROUP_LIST]: groupRecieved,
  [actions.STORE_GROUP_LABEL_VALUE_LIST]: storeGroupLabelValue,
  [actions.SAVE_PERMISSION_LIST]: permissionListRecieved,
  [actions.SAVE_USER_LIST]: usersListRecieved,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
